import type { ProtectMerchantsPortalRouter } from "@src/backend/src/protect/functions/merchantsPortal";
import { createTRPCContext } from "@trpc/tanstack-react-query";

export const {
  TRPCProvider: ProtectTRPCContextProvider,
  useTRPC: useProtectTRPC,
  useTRPCClient: useProtectTRPCClient,
} = createTRPCContext<ProtectMerchantsPortalRouter>();
